module.exports = __webpack_public_path__ + "img/4.5dd1c0ca.png";